import { render, staticRenderFns } from "./tenant-change.vue?vue&type=template&id=4de23f93&"
import script from "./tenant-change.vue?vue&type=script&lang=js&"
export * from "./tenant-change.vue?vue&type=script&lang=js&"
import style0 from "./tenant-change.vue?vue&type=style&index=0&id=4de23f93&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports